var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ArticleNameElement from "../../components/articleattributes/articlenameelement.vue";
import MaterialElement from "../../components/articleattributes/materialelement.vue";
import ThicknessElement from "../../components/articleattributes/thicknesselement.vue";
import { isValid, laserMaterialMap, } from "../utilities/material";
import { thicknessConfig, } from "../utilities/thickness";
let GeneralInformationView = class GeneralInformationView extends Vue {
    constructor() {
        super(...arguments);
        this.articleName = "Default";
        this.material = {
            invalid: true,
            cuttingGasId: "",
            material: {
                name: "",
                description: "",
                identifier: "",
            },
        };
        this.thickness = -1.;
    }
    transferData() {
        return {
            articleName: this.articleName,
            thickness: this.thickness,
            material: this.material,
            valid: this.valid,
        };
    }
    setThickness(value) {
        this.thickness = value;
        const materialFind = (m) => m.material.identifier === this.material.material.identifier && m.cuttingGasId === this.material.cuttingGasId;
        const laserMaterial = this.laserMaterialMap.find(lm => lm.materials.some(materialFind));
        if (laserMaterial === undefined) {
            throw Error("Missing material.");
        }
        const m = laserMaterial.materials.find(materialFind);
        if (m === undefined) {
            throw Error("Missing material.");
        }
        this.material = m;
        this.transferData();
    }
    setMaterial(m) {
        this.material = m;
        this.transferData();
    }
    setName(n) {
        this.articleName = n;
        this.transferData();
    }
    get nameValid() { return this.articleName !== ""; }
    get valid() { return !this.material.invalid && this.nameValid; }
    get laserMaterialMap() { return laserMaterialMap(this.shopConfig, (m) => !isValid(this.shopConfig, [this.thickness], m.material.identifier, m.cuttingGasId)); }
    get thicknessConfig() {
        return thicknessConfig(this.shopConfig, this.bendPart, undefined, this.i18n);
    }
    mounted() {
        this.articleName = this.i18n.t("article") + "_1";
        if (this.thicknessConfig.length === 0) {
            throw Error("No valid thickness.");
        }
        this.thickness = this.thicknessConfig[0].number;
        const lm = this.laserMaterialMap.find(d => d.materials.some(m => !m.invalid));
        if (lm === undefined) {
            this.material = this.laserMaterialMap[0].materials[0];
        }
        else {
            const m = lm.materials.find(m => !m.invalid);
            if (m === undefined) {
                throw Error("Missing valid material gas combination");
            }
            this.material = m;
        }
        this.transferData();
    }
    created() {
    }
};
__decorate([
    Prop({ required: true })
], GeneralInformationView.prototype, "bendPart", void 0);
__decorate([
    Prop({ required: true })
], GeneralInformationView.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], GeneralInformationView.prototype, "i18n", void 0);
__decorate([
    Emit()
], GeneralInformationView.prototype, "transferData", null);
GeneralInformationView = __decorate([
    Component({
        components: {
            ArticleNameElement,
            MaterialElement,
            ThicknessElement,
        },
        name: "GeneralInformationView",
    })
], GeneralInformationView);
export default GeneralInformationView;
